import { drawImage, getContext, getImage } from './images.js'
import { CollidesWithLayer, currentLevel, tileset } from './game.js'

class Particle {
    constructor(image, x, y, vx, vy, composition, onDestroy, onUpdate) {
        this.x = parseInt(x)
        this.y = parseInt(y)
        this.w = 2
        this.h = 2

        this.elapsed = 0

        this.movement = { x: vx, y: vy }

        this.destroyNonMoving = true
        this.destroyAfterAnimation = false

        this.opacity = 1

        this.ctx = getContext()

        this.friction = 0.05

        this.state = image

        this.composition = composition ? composition : 'source-over'

        this.animationFrame = 0
        this.animationSpeed = 0.09

        this.minVecX = 0.03
        this.minVecY = 0.03

        this.onDestroy = onDestroy ? onDestroy : (p) => {}
        this.onUpdate = onUpdate ? onUpdate : (p, delta) => {}
    }

    AnimationFramesCount() {
        let img = getImage(this.state)
        return parseInt(img.width / this.w)
    }

    AnimationFrame(frame) {
        if (frame !== undefined) {
            this.animationFrame = frame
        }
        return parseInt(this.animationFrame)
    }

    ShouldAnimationPlay() {
        return true
    }

    AnimationAdvance(delta) {
        if (!this.ShouldAnimationPlay()) {
            return parseInt(this.animationFrame)
        }
        this.animationFrame += delta * this.animationSpeed
        if (this.animationFrame > this.AnimationFramesCount()) {
            if (this.destroyAfterAnimation) {
                this.Destroy()
                return
            }
            this.animationFrame = 0
        }
        return parseInt(this.animationFrame)
    }

    Destroy() {
        this.onDestroy(this)
    }

    Draw(offsetx, offsety) {
        offsetx = offsetx === undefined ? 0 : offsetx
        offsety = offsety === undefined ? 0 : offsety
        let op = this.ctx.globalCompositeOperation
        this.ctx.globalCompositeOperation = this.composition
        let opacity = this.ctx.globalAlpha
        this.ctx.globalAlpha = this.opacity
        drawImage(this.state, parseInt(this.x + offsetx), parseInt(this.y + offsety), { x: this.AnimationFrame() * this.w, y: 0, w: this.w, h: this.h })
        this.ctx.globalCompositeOperation = op
        this.ctx.globalAlpha = opacity
    }

    Update(delta) {
        delta = delta ? delta : 16

        this.elapsed += delta

        this.movement.x = (this.movement.x * (1 - this.friction))
        this.movement.y = (this.movement.y * (1 - this.friction))
        
        if (this.onUpdate) {
            this.onUpdate(this, delta)
        }

        let dx = this.movement.x * delta
        let dy = this.movement.y * delta

        if (this.destroyNonMoving) {
            if (this.movement.x !== 0 && Math.abs(this.movement.x) > 0 && Math.abs(this.movement.x) < this.minVecX) {
                this.movement.x = 0
            }
            if (this.movement.y !== 0 && Math.abs(this.movement.y) > 0 && Math.abs(this.movement.y) < this.minVecY) {
                this.movement.y = 0
            }
            
            if ((this.minVecX > 0 && this.movement.x === 0) && (this.minVecY > 0 && this.movement.y === 0)) {
                this.Destroy()
            }
            //  else if (CollidesWithLayer({ x: this.x, y: this.y, w: this.w, h: this.h }, 1)) {
            //     this.Destroy()
            // }
        }

        this.x += dx
        this.y += dy

        // if (this.x > currentLevel.width * tileset.tilewidth || this.y > currentLevel.height * tileset.tileheight || this.x < 0 || this.y < 0) {
        //     this.Destroy()
        // }

        this.AnimationAdvance(delta)
    }
}

export default Particle